import { useMutation } from '@tanstack/react-query';
import { createFunctionalChecklist } from '../services/functional_checklist';

const useCreateFunctionalChecklist = () => {
    const createChecklistMutation = useMutation({
        queryKey: ['create_functional_checklist'],
        mutationFn: createFunctionalChecklist
    });
    
    return createChecklistMutation;
};

export default useCreateFunctionalChecklist; 